import CopyLink from '@anm/components/CopyLink';
import TabUrlParamsForm, {
  FieldProps,
  ParamsFields
} from '@anm/components/form/TabUrlParamsForm';
import noop from '@anm/helpers/noop';
import useSwitchState from '@anm/hooks/useSwitchState';
import { FC } from 'react';

import {
  CopyLinkWrapper,
  ParamsButton,
  ParamsDescription,
  ParamsWrapper,
  RelativeBlock,
  Subtitle,
  SwitcherTitleWrapper
} from './Wrapper';

export type FormValues = { [key: string]: string };

type TabUrlParametersProps = {
  fields: FieldProps[][];
  formInitialValues: FormValues;
  title?: string;
  snippet?: string;
  useForm?: boolean;
  paramsDescription?: string;
  onCopyCode?(): void;
  onFormBlur?(values: FormValues): void;
};

const DEFAULT_PARAMS_DESCRIPTION =
  'Fill in the fields in the form below to add parameters to your website URL.';

const TabUrlParameters: FC<TabUrlParametersProps> = ({
  title,
  snippet,
  fields,
  useForm = true,
  formInitialValues,
  children,
  paramsDescription = DEFAULT_PARAMS_DESCRIPTION,
  onFormBlur = noop,
  onCopyCode = noop
}) => {
  const [isOpenParams, , , toogleOpenParams] = useSwitchState();

  return (
    <RelativeBlock>
      <ParamsButton onClick={toogleOpenParams}>
        {`${isOpenParams ? 'Hide' : 'Show'} URL parameters`}
      </ParamsButton>
      {children}
      {isOpenParams && (
        <ParamsWrapper>
          <ParamsDescription>{paramsDescription}</ParamsDescription>
          {useForm ? (
            <TabUrlParamsForm
              fields={fields}
              initialValues={formInitialValues}
              onSubmit={noop}
              onBlur={onFormBlur}
            />
          ) : (
            <ParamsFields fields={fields} />
          )}
        </ParamsWrapper>
      )}
      {title && (
        <SwitcherTitleWrapper>
          <Subtitle {...{ title }} level={4} />
        </SwitcherTitleWrapper>
      )}
      {snippet && (
        <CopyLinkWrapper>
          <CopyLink
            multirows
            autoResize
            key={snippet}
            link={snippet}
            direction="vertical"
            buttonSize="medium"
            buttonText="Copy code"
            inputVariant="disabled_gray"
            buttonVariant="white-blue-border-hosting"
            onCopy={onCopyCode}
          />
        </CopyLinkWrapper>
      )}
    </RelativeBlock>
  );
};

export default TabUrlParameters;
